export const ROLE_CATEGORIES = {
  predefined: 'predefined',
  custom: 'custom',
} as const;

export type RoleCategory =
  (typeof ROLE_CATEGORIES)[keyof typeof ROLE_CATEGORIES];

export function isRoleCategory(
  roleCategory: string | undefined,
): roleCategory is RoleCategory {
  return (
    roleCategory === ROLE_CATEGORIES.predefined ||
    roleCategory === ROLE_CATEGORIES.custom
  );
}

export interface RoleSelectOption {
  label: string;
  value: string;
}

export interface RolePermissionNode {
  id: string;
  label: string;
  description?: string;
  children?: RolePermissionNode[];
}

export interface RoleTextModifierField {
  id: string;
  label: string;
  value: string;
  inputType: 'text';
}

export interface RoleSelectModifierField {
  id: string;
  label: string;
  value: string;
  inputType: 'select';
  options: RoleSelectOption[];
}

export type RoleModifierField = RoleTextModifierField | RoleSelectModifierField;

export interface RoleModifierFormValue {
  id: string;
  value: string;
}

export interface RoleDetailsFormValues {
  name: string;
  teamId: string;
  description: string;
  modifiers: RoleModifierFormValue[];
  selectedPermissionIds: string[];
}

export interface RoleDetailsModel {
  id: string;
  category: RoleCategory;
  roleType: 'FUNCTIONAL' | 'TEAM';
  name: string;
  description: string;
  teamId: string;
  teamName: string;
  usesInclusionTree: boolean;
  selectedPermissionIds: string[];
  permissionTree: RolePermissionNode[];
  modifiers: RoleModifierField[];
}
